/**
 * @description: 区域影像切片图层
 * @return: 区域影像切片图层layer
 */
const L = window.L;
import { getStorage } from "@/utils/storage";
import getGisToken from "@/mixins/map/getGisToken";
async function areaTileLayer() {
  // 获取区域性高清卫星影像服务图层  查询是否有卫星影像（墨卡托） 服务，类似旌阳单独部署有卫星影像
  let gisServerList = getStorage("GISSERVERLIST") || [];
  let gisServer = gisServerList.filter(
    (item) => item && item.serverCategory && item.serverCategory === 22
  );
  if (!gisServer.length) return;
  const areaTileBaseUrl = gisServer[0]["serverUrl"];
  let token = await getGisToken("area", areaTileBaseUrl);
  let areaTileUrl =
    gisServer[0]["serverUrl"] + "/tile/{z}/{y}/{x}?token=" + token;
  L.GridLayer.include({
    _setZoomTransform: function (level, center, zoom) {
      if (center != undefined && this.options) {
        // 获取切片某坐标的切片 此处做坐标转换
        if (
          Reflect.has(this.options, "coordHander") &&
          Reflect.has(L.coordTransform(), this.options.coordHander)
        ) {
          center = L.coordTransform()[this.options.coordHander](
            center.lng,
            center.lat
          );
        }
      }
      var viewHalf = this._map.getSize().divideBy(2);
      var mapProject = this._map.project(center, zoom);
      var mapPanePos = this._map._mapPane._leaflet_pos;
      var newPixelOrigin = mapProject
        .subtract(viewHalf)
        ._add(mapPanePos)
        .round();
      var scale = this._map.getZoomScale(zoom, level.zoom),
        translate = level.origin
          .multiplyBy(scale)
          .subtract(newPixelOrigin)
          .round();
      if (L.Browser.any3d) {
        L.DomUtil.setTransform(level.el, translate, scale);
      } else {
        L.DomUtil.setPosition(level.el, translate);
      }
    },
    // 获取地图容器像素四至，根据修改后的鼠标中心点获取
    _getTiledPixelBounds: function (center) {
      if (center != undefined && this.options) {
        // 获取切片某坐标的切片 此处做坐标转换
        if (
          Reflect.has(this.options, "coordHander") &&
          Reflect.has(L.coordTransform(), this.options.coordHander)
        ) {
          center = L.coordTransform()[this.options.coordHander](
            center.lng,
            center.lat
          );
        }
      }
      var map = this._map,
        mapZoom = map._animatingZoom
          ? Math.max(map._animateToZoom, map.getZoom())
          : map.getZoom(),
        scale = map.getZoomScale(mapZoom, this._tileZoom),
        pixelCenter = map.project(center, this._tileZoom).floor(),
        halfSize = map.getSize().divideBy(scale * 2);
      return new L.Bounds(
        pixelCenter.subtract(halfSize),
        pixelCenter.add(halfSize)
      );
    },
  });
  L.CoordTransform = CoordTransform;
  L.coordTransform = function () {
    return new L.CoordTransform();
  };
  return new L.tileLayer(areaTileUrl, {
    id: "layer_jyTianditu",
    className: "layer_jyTianditu",
    subdomains: "01234567",
    maxZoom: 22,
    minZoom: 0,
    maxNativeZoom: 19,
    zIndex: 5,
    tileSize: 256,
    coordHander: "gcj02_To_wgs84", // gcj02_To_wgs84, bd09_To_wgs84, wgs84_To_bd09, wgs84_To_gcj02, gcj02_To_bd09, bd09_To_gcj02
  });
}
function CoordTransform() {
  //bd09转wgs84
  this.bd09_To_wgs84 = function (lng, lat) {
    var gcj02 = this.bd09_To_gcj02(lng, lat);
    var wgs84 = this.gcj02_To_wgs84(gcj02.lng, gcj02.lat);
    return wgs84;
  };
  //wgs84转bd09
  this.wgs84_To_bd09 = function (lng, lat) {
    var gcj02 = this.wgs84_To_gcj02(lng, lat);
    var bd09 = this.gcj02_To_bd09(gcj02.lng, gcj02.lat);
    return bd09;
  };
  //wgs84转gcj02
  this.wgs84_To_gcj02 = function (lng, lat) {
    var dLat = transformLat(lng - 105.0, lat - 35.0);
    var dLng = transformLng(lng - 105.0, lat - 35.0);
    var radLat = (lat / 180.0) * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
    dLng = (dLng * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
    var mgLat = lat + dLat;
    var mgLng = lng + dLng;
    var newCoord = {
      lng: mgLng,
      lat: mgLat,
    };
    return newCoord;
  };
  //gcj02转wgs84
  this.gcj02_To_wgs84 = function (lng, lat) {
    var coord = transform(lng, lat);
    var lontitude = lng * 2 - coord.lng;
    var latitude = lat * 2 - coord.lat;
    var newCoord = {
      lng: lontitude,
      lat: latitude,
    };
    return newCoord;
  };
  //gcj02转bd09
  this.gcj02_To_bd09 = function (lng, lat) {
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_pi);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_pi);
    var bd_lng = z * Math.cos(theta) + 0.0065;
    var bd_lat = z * Math.sin(theta) + 0.006;
    var newCoord = {
      lng: bd_lng,
      lat: bd_lat,
    };
    return newCoord;
  };
  //bg09转gcj02
  this.bd09_To_gcj02 = function (lng, lat) {
    var x = lng - 0.0065;
    var y = lat - 0.006;
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    var lontitude = z * Math.cos(theta);
    var latitude = z * Math.sin(theta);
    var newCoord = {
      lng: lontitude,
      lat: latitude,
    };
    return newCoord;
  };
  var pi = 3.1415926535897932384626;
  var a = 6378245.0;
  var ee = 0.00669342162296594323;
  var x_pi = (pi * 3000.0) / 180.0;
  function transform(lng, lat) {
    var dLat = transformLat(lng - 105.0, lat - 35.0);
    var dLng = transformLng(lng - 105.0, lat - 35.0);
    var radLat = (lat / 180.0) * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
    dLng = (dLng * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
    var mgLat = lat + dLat;
    var mgLng = lng + dLng;
    var newCoord = {
      lng: mgLng,
      lat: mgLat,
    };
    return newCoord;
  }
  function transformLat(x, y) {
    var ret =
      -100.0 +
      2.0 * x +
      3.0 * y +
      0.2 * y * y +
      0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) / 3.0;
    ret +=
      ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) *
        2.0) /
      3.0;
    return ret;
  }
  function transformLng(x, y) {
    var ret =
      300.0 +
      x +
      2.0 * y +
      0.1 * x * x +
      0.1 * x * y +
      0.1 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) / 3.0;
    ret +=
      ((150.0 * Math.sin((x / 12.0) * pi) + 300.0 * Math.sin((x / 30.0) * pi)) *
        2.0) /
      3.0;
    return ret;
  }
}
export default areaTileLayer;
